import { combineReducers } from 'redux';

/* Reducers: */
const listAll = (state = {
  isFetching: false,
  support: {},
  about: {},
}, action) => {
  const { type, pageId, response } = action;
  switch (type) {
    case 'REQUEST_PAGE': // eslint-disable-line no-case-declarations
      return { ...state, isFetching: true };
    case 'RECIEVE_PAGE': // eslint-disable-line no-case-declarations
      if (typeof pageId === 'undefined') {
        return state;
      }
      const page = {
        [pageId]: response,
      };
      return { ...state, ...page, isFetching: false };
    default:
      return state;
  }
};

const pages = combineReducers({
  listAll,
});

export default pages;

/* Selectors: */
export const getIsFetching = state => state.listAll.isFetching;

export const getPage = (state, pageId) =>
  state.listAll[pageId];



// WEBPACK FOOTER //
// ./js/reducers/pages.js